import React from 'react';
import styled, { css } from 'styled-components';
import smallBorderStyle from '../utils/smallBorderStyle';
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

export default ({ children, ...rest }) => (
  <Title {...rest}>{children}</Title>
);

const Title = styled.h1`
  position: relative;
  margin-top: 0;
  margin-bottom: 0;

  ${props => props.small && css`
    font-size: 1rem;
  `};

  ${props => props.theme.isMobile && css`
    line-height: 1.125;
    font-size: 1.25rem;
  `}
`;
